var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('amplify-authenticator',[_c('div',[_c('h1',[_vm._v("Hey, "+_vm._s(_vm.user.username)+"!")]),_c('amplify-sign-out')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }